<template>
  <div>
    <span>Reset <a v-b-tooltip.hover title="Call / SMS Credtis will be reset at 1PM UTC" class="fa fa-question-circle tooltip-icon" /></span>
  </div>
</template>
<script>
export default {
}
</script>